import { Icon, Image, theme } from 'components';
import React from 'react';
import styled from 'styled-components';

export interface ListingImageProps {
  thumbnail?: string;
}

const IMAGE_SIZE = 40;

const ListingImage: React.FC<ListingImageProps> = ({ thumbnail }) => (
    <StyledImageContainer>
      <StyledImage
        src={thumbnail}
        preview={false}
        placeholder={<Icon type="antdHomeFilled" />}
      />
    </StyledImageContainer>
  );

export default React.memo(ListingImage);

const StyledImageContainer = styled.div`
  display: flex;

  & .ant-image-placeholder {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${theme.gray5};
    border-radius: ${theme.getBorderRadius('medium')};
  }
`;

// @TODO APP-5718: See if Thumbnail component can be used here when adding skeletons
const StyledImage = styled(Image).attrs({
  width: IMAGE_SIZE,
  height: IMAGE_SIZE,
})`
  object-fit: cover;
  border-radius: ${theme.getBorderRadius('medium')};
`;
